(() => {
  const start = () => {
    const footer = document.querySelector('footer');
    if (!footer) return;
    const label = document.documentElement.lang.toLowerCase().startsWith('de')
      ? 'Vertrag widerrufen' : 'Withdraw from contract';
    const translate = () => {
      footer.querySelectorAll('a,button').forEach(button => {
        if (!['Vertrag widerrufen', 'Withdraw from contract'].includes(button.textContent.trim())) return;
        const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (['Vertrag widerrufen', 'Withdraw from contract'].includes(node.textContent.trim()) && node.textContent.trim() !== label) node.textContent = label;
        }
        if (button.hasAttribute('aria-label')) button.setAttribute('aria-label', label);
      });
    };
    translate();
    new MutationObserver(translate).observe(footer, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
